import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import axios from '../../http-config';
import MenuItem from '@material-ui/core/MenuItem';
import { Grid } from '@material-ui/core';
import swal from 'sweetalert';
import { IconButton } from '@material-ui/core';
import ImageUploader from 'react-images-upload';
import CancelIcon from '@material-ui/icons/Cancel';
import * as actionsCreators from '../../store/actions/index';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { withTranslation } from 'react-i18next';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MyLocationRoundedIcon from '@material-ui/icons/MyLocationRounded';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
class Citizen extends Component {
    constructor(props) {
        super(props)
        this.handleMapClick = this.handleMapClick.bind(this);
        this.AshandleMapClick = this.AshandleMapClick.bind(this);
        this.state = {
            maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo",
            id: "",
            buildingName: "",
            ownerName: "",
            propType: "",
            area: "",
            wardNo: "",
            zone: "",
            ulbName: "",
            containmentType: "",
            buildingNameErr: "",
            ownerNameErr: "",
            propTypeErr: "",
            areaErr: "",
            wardNoErr: "",
            zoneErr: "",
            ulbNameErr: "",
            containmentTypeErr: "",
            propertyOptions: [],
            containmentOptions: [],
            ulbOptions: [],
            areaOptions: [],
            wardOptions: [],
            onUlb: false,
            emergency: "",
            onUlbName: '',
            reason: this.props.reason ? this.props.reason : '',
            reasonErr: '',
            ZoneOptions: [],

            selectDayMonth: '',
            months: '',
            days: '',
            img: {
                name: "",
            },
            imgErr: "",
            isLogo: false,
            emergencyErr: '',
            searchByFields: '',
            phoneNumber: '',
            phoneNumberErr: '',
            PPhoneNumber: '',
            captcha: '',
            form: {
                buildingName: "",
                ownerName: "",
                propType: "",
                area: "",
                wardNo: "",
                zone: "",
                ulbName: "",
                containmentType: "",

            },

            randomCaptcha: '',
            captchaErr: '',
            pincode: "",
            pincodeErr: "",
            houseNo: "",
            assessmentNo: "",
            selectSearchProperty: "select",
            usage: "",
            locality: "",
            location: {
                latitude: "",
                longitude: ""
            },
            latitude: '',
            longitude: '',
            locationName: '',
            longitudeErr: "",
            latitudeErr: "",
            openNewCreation: false,
            houseNoFlag: false,
            assessmentNoFlag: false,
            taxAssessmentArr: [],
            openHouseCreation: false,
            openTaxAssessCreation: false,
            houseNoField: "",
            assessNoField: "",
            assessNoFieldErr: "",
            houseNoFieldErr: "",
            Aslocality: "",
            AsownerName: "",
            Aspincode: "",
            AsulbName: "",
            Asusage: "",
            AsownerNameErr: "",
            AsulbNameErr: "",
            AsusageErr: "",
            AslocalityErr: "",
            usageOptions: [],
            usageOthers: "",
            Aslatitude: "",
            Aslongitude: "",
            AslongitudeErr: "",
            AslatitudeErr: "",
            currentLatitude: "",
            currentlongitude: "",
            zoom: 18,
            center: {
                lat: "",
                lng: ""
            },
            optOptions: [],
            operatorName: "",
            opertorErr: "",
            asCenter: {
                lat: "",
                lng: ""
            },

            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            timeRange: "08:00 AM - 10:00 AM",
            startRangeTime: "",
            endRangeTime: ""
        }

    }

    async componentDidMount() {
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const center = {
                lat: latitude,
                lng: longitude
            }
            this.setState({
                latitude: latitude,
                longitude: longitude,
                center: center,
                zoom: 18
            });
        };

        const error = () => {
            const tsCenter = {
                lat: 17.123184,
                lng: 79.208824,
            }
            this.setState({
                latitude: 17.123184,
                longitude: 79.208824,
                center: tsCenter,
                zoom: 7
            });
            console.log("Unable to retrieve your location");
        };
        navigator.geolocation.getCurrentPosition(success, error);


        axios({
            method: 'get',
            url: '/auth/getContainmentType',
        })
            .then((response) => {

                this.setState({
                    containmentOptions: response.data.data
                })
            })


        axios({
            method: 'get',
            url: '/auth/usageType',
        })
            .then((response) => {
                this.setState({
                    usageOptions: response.data.data.usageType
                })
            })

        axios({
            method: 'get',
            url: '/property_type',

        })
            .then((response) => {

                this.setState({
                    propertyOptions: response.data.data.propertyTypes
                })
            })
        axios({
            method: 'get',
            url: '/auth/getAllUlb',

        })
            .then((response) => {
                // displaying the parent ULB on top & clusters below that
                const newArr1 = []
                newArr1.push(response.data.data.filter((option) => option.Code !== null))
                const newArr2 = []
                newArr2.push(response.data.data.filter((option) => option.Code == null))
                const newArr3 = newArr1[0].concat(newArr2[0])
                this.setState({
                    ulbOptions: newArr3
                })
            })

        this.generateString(6)
    }


    handleChange = (event) => {
        if (event.target.name == "houseNo" && event.target.value == "") {
            this.setState({
                houseNo: "",
                ownerName: "",
                locality: "",
                usage: "",
                pincode: "",
                ulbName: "",
                assessNoField: "",
                houseNoField: "",
                latitude: "",
                longitude: "",
                ownerName: "",
                buildingName: "",
                propType: "",
                area: "",
                wardNo: "",
                zone: "",
                containmentType: "",
                selectDayMonth: '',
                months: '',
                days: '',
                img: {
                    name: "",
                },
                searchByFields: '',
                phoneNumber: '',
                emergency: "",
                reason: "",
                captcha: "",
                houseNoFlag: false,
                operatorName: "",
                selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
                timeRange: "08:00 AM - 10:00 AM",
                optOptions:[]

            })

        }
        if (event.target.name == "assessmentNo" && event.target.value == "") {
            this.setState({
                Aslocality: "",
                AsownerName: "",
                Aspincode: "",
                AsulbName: "",
                Asusage: "",
                houseNoField: "",
                assessNoField: "",
                Aslatitude: "",
                Aslongitude: "",
                buildingName: "",
                propType: "",
                area: "",
                wardNo: "",
                zone: "",
                containmentType: "",
                selectDayMonth: '',
                months: '',
                days: '',
                img: {
                    name: "",
                },
                searchByFields: '',
                phoneNumber: '',
                emergency: "",
                reason: "",
                captcha: "",
                assessmentNoFlag: false,
                operatorName: "",
                selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
                timeRange: "08:00 AM - 10:00 AM",
                optOptions:[]
            })
        }
        if (event.target.name == "ulbName") {
            axios({
                method: 'get',
                url: `/auth/dropDown?ULBId=${event.target.value}`,

            })
                .then((response) => {
                    this.setState({
                        optOptions: response.data.data.operators
                    })
                })
        }
        if (event.target.name == "timeRange") {
            const splitTime = event.target.value.split(" - ") //['08:10 AM', '10:00 AM']
            const startRangeTime = splitTime[0] // 08:00 AM
            const endTimeRange = splitTime[1]  // 10:00 AM
            this.setState({ startRangeTime: startRangeTime, endRangeTime: endTimeRange })

        }
        this.setState({ [event.target.name]: event.target.value }, () => {
            this.checkValidity()
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const err = this.checkValidity()
        if (!err) {
            const formdata = new FormData()
            if (this.state.assessmentNo != "") {
                formdata.append("Name", this.state.buildingName)
                formdata.append("OwnerName", this.state.AsownerName)
                formdata.append("PropertyTypeId", this.state.propType)
                formdata.append("ContainmentTypeId", this.state.containmentType)
                formdata.append("Zone", this.state.zone)
                formdata.append("Number", this.state.wardNo)
                formdata.append("Emergency", this.state.emergency)
                formdata.append("LastEmptiedDays", this.state.days)
                formdata.append("LastEmptiedMonths", this.state.months)
                formdata.append("Comments", this.state.reason)
                formdata.append("Photo", this.state.img.name)
                formdata.append("PhoneNumber", this.state.phoneNumber)
                formdata.append("ULBId", this.state.AsulbName)
                formdata.append("PinCode", this.state.Aspincode)//sending data to api
                formdata.append("UsageId", this.state.Asusage)//sending data to api
                formdata.append("ASSESSMENT_NO", this.state.assessmentNo)//sending data to api
                formdata.append("OWNER_DOORNO", this.state.houseNoField != "" ? this.state.houseNoField : "")//sending data to api
                formdata.append("Latitude", this.state.Aslatitude)//sending data to api
                formdata.append("Longitude", this.state.Aslongitude)//sending data to api
                formdata.append("Locality", this.state.Aslocality)//sending data to api
                formdata.append("operatorId", this.state.operatorName)
                formdata.append("UpcomingColletionDate", this.state.selectedDate)
                formdata.append("UpcomingColletionStartTime", this.state.startRangeTime)
                formdata.append("UpcomingColletionEndTime", this.state.endRangeTime)

            }
            else {
                formdata.append("Name", this.state.buildingName)
                formdata.append("OwnerName", this.state.ownerName)
                formdata.append("PropertyTypeId", this.state.propType)
                formdata.append("ContainmentTypeId", this.state.containmentType)
                formdata.append("Zone", this.state.zone)
                formdata.append("Number", this.state.wardNo)
                formdata.append("Emergency", this.state.emergency)
                formdata.append("LastEmptiedDays", this.state.days)
                formdata.append("LastEmptiedMonths", this.state.months)
                formdata.append("Comments", this.state.reason)
                formdata.append("Photo", this.state.img.name)
                formdata.append("PhoneNumber", this.state.phoneNumber)
                formdata.append("ULBId", this.state.ulbName)
                formdata.append("PinCode", this.state.pincode)//sending data to api
                formdata.append("UsageId", this.state.usage)//sending data to api
                formdata.append("ASSESSMENT_NO", this.state.assessNoField)//sending data to api
                formdata.append("OWNER_DOORNO", this.state.houseNo != "" ? this.state.houseNo : this.state.houseNoField != "" ? this.state.houseNoField : "")//sending data to api
                formdata.append("Latitude", this.state.latitude)//sending data to api
                formdata.append("Longitude", this.state.longitude)//sending data to api
                formdata.append("Locality", this.state.locality) //sending data to api
                formdata.append("operatorId", this.state.operatorName)
                formdata.append("UpcomingColletionDate", this.state.selectedDate)
                formdata.append("UpcomingColletionStartTime", this.state.startRangeTime)
                formdata.append("UpcomingColletionEndTime", this.state.endRangeTime)

            }
            swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: 'No',
                    confirm: 'Yes'
                }
            })
                .then((will) => {

                    if (will && !err) {
                        this.props.onCitizenPropertyAdd(formdata, this.props)
                    }
                });

        } else {
            swal({
                icon: "error",
                title: "Kindly fill all required fields."
            })
        }
    }

    checkValidity = () => {
        let isError = false
        if (!this.state.containmentType) {
            isError = true
            this.setState({ containmentTypeErr: '*Required Field' })
        }
        else {
            isError=false
            this.setState({ containmentTypeErr: '' })
        }

        if (this.state.assessmentNo != "") {
            if (this.state.AsownerName == "") {
                isError = true
                this.setState({ AsownerNameErr: '*Required Field' })
            }
            else {
                isError=false
                this.setState({ AsownerNameErr: '' })
            }

            if (this.state.Aslongitude == "") {
                isError = true
                this.setState({ AslongitudeErr: `${("*Required Field")}` })
            } else {
                isError=false
                this.setState({ AslongitudeErr: '' })
            }
            if (this.state.Aslatitude == "") {
                isError = true
                this.setState({ AslatitudeErr: `${("*Required Field")}` })
            } else {
                isError=false
                this.setState({ AslatitudeErr: '' })
            }


            if (this.state.AsulbName == "") {
                isError = true
                this.setState({ AsulbNameErr: `${("*Required Field")}` })
            } else {
                isError=false
                this.setState({ AsulbNameErr: "" })
            }
        } else {

            if (this.state.ownerName == "") {
                isError = true
                this.setState({ ownerNameErr: '*Required Field' })
            }
            else {
                isError=false
                this.setState({ ownerNameErr: '' })
            }
            if (this.state.latitude == "") {
                isError = true
                this.setState({ latitudeErr: `${("*Required Field")}` })
            } else {
                isError=false
                this.setState({ latitudeErr: '' })
            }


            if (this.state.longitude == "") {
                isError = true
                this.setState({ longitudeErr: `${("*Required Field")}` })
            } else {
                this.setState({ longitudeErr: '' })
            }

            if (this.state.ulbName == "") {
                isError = true
                this.setState({ ulbNameErr: `${("*Required Field")}` })
            }
            else {
                isError=false
                this.setState({ ulbNameErr: "" })
            }
        }

        if (!this.state.propType) {
            isError = true
            this.setState({ propTypeErr: '*Required Field' })
        }
        else {
            isError=false
            this.setState({ propTypeErr: '' })
        }


        if (this.state.buildingName == "") {
            isError = true
            this.setState({ buildingNameErr: "*Required Field" })
        }
        else {
            isError=false
            this.setState({ buildingNameErr: '' })
        }
        //    if(!this.state.phoneNumber){
        //         isError=true
        //         this.setState({phoneNumberErr : "*This field is required"})
        //     }
        if (this.state.phoneNumber == "") {
            isError = true
            this.setState({ phoneNumberErr: "*Required Field" })
        }
        else if (this.state.phoneNumber) {
            if (!this.state.phoneNumber.match(/^[0-9]{10,10}$/)) {
                isError = true
                this.setState({ phoneNumberErr: '*Enter Valid Contact Number' })
            }

            else {
                if (this.state.phoneNumber.length === 10) {
                    isError = false
                    this.setState({ phoneNumberErr: '' })
                }
            }
        } else {
            this.setState({ phoneNumberErr: '' })
        }
        if (!this.state.captcha) {
            isError = true
            this.setState({ captchaErr: '*Please enter the captcha.' })
        } else if (this.state.captcha != this.state.randomCaptcha) {
            isError = true
            this.setState({ captchaErr: '*Incorrect Captch entered' })
        } else {
            isError = false
            this.setState({ captchaErr: '' })
        }
        // added validation for if zones no. are unknown and you have ward no.
        if (this.state.wardNo != "") {
            if (this.state.zone != "") {
                isError = false
                this.setState({ zoneErr: "" })
            } else {
                isError = true
                this.setState({ zoneErr: `${('Kindly enter "NA" if you are unknown to zone no.')}` })
            }
        }
        else {
            isError = true
            this.setState({ zoneErr: "*Required Field" })
        }
        // added validation for if zones no. are unknown and you have ward no.
        if (this.state.zone != "") {
            if (this.state.wardNo != "") {
                isError = false
                this.setState({ wardNoErr: "" })
            } else {
                isError = true
                this.setState({ wardNoErr: `${('Kindly enter "NA" if you are unknown to ward no.')}` })
            }
        }
        else {
            isError = true
            this.setState({ wardNoErr: "*Required Field" })
        }
        // validition for pincode field. 
        // if (!this.state.pincode) {
        //     isError = true
        //     this.setState({ pincodeErr: `${("*Required Field")}` })
        // }
        // else if (this.state.pincode) {
        //     if (!this.state.pincode.match(/^[0-9]{6,6}$/)) {
        //         isError = true
        //         this.setState({ pincodeErr: `${("please enter 6 digits pincode.")}` })
        //     }
        //     else {
        //         if (this.state.pincode.length === 6) {
        //             isError = false
        //             this.setState({ pincodeErr: '' })
        //         }

        //     }

        // } else {
        //     this.setState({ pincodeErr: '' })
        // }
        if (this.state.operatorName == "") {
            isError = true
            this.setState({ opertorErr: `${("Please select the ULB.")}` })
        } else {
            // isError = false
            this.setState({ opertorErr: `${("")}` })
        }
        return isError
    }
    handleImage = (e) => {
        this.setState({ img: e[0], isLogo: true })
    }
    handleRemove = () => {
        this.setState({ img: { name: '' }, isLogo: false })
    }
    generateString = (length) => {
        let result = '';
        const characters = 'abc123';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        this.setState({ randomCaptcha: result })
        return result;
    }
    handleCancle = () => {
        swal({
            title: "Are you sure?",
            text: "Once it is cancelled, it can not be retrieved.",
            icon: "warning",
            buttons: {
                cancel: 'No',
                confirm: 'Yes'
            }
        })
            .then((will) => {
                if (will) {
                    this.props.history.push('/')
                }
            })
    }

    handleSearchHouseNo = (data) => {

        if (data != "") {
            axios({
                method: 'get',
                url: `/auth/propertyTax?ownerDoor=${data}`,
            })
                .then((response) => {
                    if (response.data.data.propertytax.length === 0) {
                        this.setState({
                            assessmentNoFlag: false,
                            houseNoFlag: false,
                        })
                        swal({
                            icon: "error",
                            title: "No Record Found!!"
                        })
                    }
                    else {
                        const tlCenter = {
                            lat: !!response.data.data.propertytax.length != 0 ? Number(response.data.data.propertytax[0].Lattitude) : "",
                            lng: !!response.data.data.propertytax.length != 0 ? Number(response.data.data.propertytax[0].Longitude) : ""
                        }
                        this.setState({
                            assessmentNoFlag: false,
                            houseNoFlag: true,
                            ownerName: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].OwnerName : "",
                            locality: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].Locality : "",
                            latitude: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].Lattitude : "",
                            longitude: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].Longitude : "",
                            usage: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].Usage : "",
                            ulbName: !!response.data.data.propertytax ? response.data.data.propertytax[0].ULBName : "",
                            pincode: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].Pincode : "",
                            // houseNoField: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].OWNER_DOORNO : "",
                            assessNoField: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].ASSESSMENT_NO : "",
                            Aslocality: "",
                            AsownerName: "",
                            Aspincode: "",
                            AsulbName: "",
                            Asusage: "",
                            Aslatitude: "",
                            Aslongitude: "",
                            buildingName: "",
                            propType: "",
                            area: "",
                            operatorName: "",
                            // ulbName: "",
                            containmentType: "",
                            wardNo: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].WardNo : "",
                            zone: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].ZoneNo : "",
                            // operatorName : !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].operatorId : "",
                            center: tlCenter,
                            zoom: 18,
                            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
                            timeRange: "08:00 AM - 10:00 AM",


                        }, () => {
                            if (this.state.ulbName != "") {
                                axios({
                                    method: 'get',
                                    url: `/auth/dropDown?ULBId=${this.state.ulbName}`,

                                })
                                    .then((response) => {
                                        this.setState({
                                            optOptions: response.data.data.operators
                                        })
                                    })
                            }
                        })



                    }

                }).catch((err) => {
                    swal({
                        icon: "error",
                        title: "API Issue"
                    })
                })
        }
    }

    handleSearchAssessmentNo = (target) => {
        if (target != "") {
            axios({
                method: 'get',
                url: `/auth/propertyTax?assessmentNo=${target}`,
            })
                .then((response) => {
                    if (response.data.data.propertytax.length === 0) {
                        this.setState({
                            assessmentNoFlag: false,
                            houseNoFlag: false,
                        })
                        swal({
                            icon: "error",
                            title: "No Record Found!!"
                        })
                    }
                    else {
                        const tlCenter = {
                            lat: !!response.data.data.propertytax.length != 0 ? Number(response.data.data.propertytax[0].Lattitude) : "",
                            lng: !!response.data.data.propertytax.length != 0 ? Number(response.data.data.propertytax[0].Longitude) : ""
                        }
                        this.setState({
                            assessmentNoFlag: true,
                            houseNoFlag: false,
                            ownerName: "",
                            locality: "",
                            usage: "",
                            pincode: "",
                            ulbName: "",
                            operatorName: "",
                            AsownerName: !!response.data.data.propertytax ? response.data.data.propertytax[0].OwnerName : "",
                            Aslocality: !!response.data.data.propertytax ? response.data.data.propertytax[0].Locality : "",
                            Aslatitude: !!response.data.data.propertytax ? response.data.data.propertytax[0].Lattitude : "",
                            Aslongitude: !!response.data.data.propertytax ? response.data.data.propertytax[0].Longitude : "",
                            Asusage: !!response.data.data.propertytax ? response.data.data.propertytax[0].Usage : "",
                            AsulbName: !!response.data.data.propertytax ? response.data.data.propertytax[0].ULBName : "",
                            Aspincode: !!response.data.data.propertytax ? response.data.data.propertytax[0].Pincode : "",
                            houseNoField: !!response.data.data.propertytax ? response.data.data.propertytax[0].OWNER_DOORNO : "",
                            // assessNoField: !!response.data.data.propertytax ? response.data.data.propertytax[0].ASSESSMENT_NO : "",
                            wardNo: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].WardNo : "",
                            zone: !!response.data.data.propertytax.length != 0 ? response.data.data.propertytax[0].ZoneNo : "",
                            asCenter: tlCenter,
                            zoom: 18,
                            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
                            timeRange: "08:00 AM - 10:00 AM",


                        }, () => {
                            if (this.state.AsulbName != "") {
                                axios({
                                    method: 'get',
                                    url: `/auth/dropDown?ULBId=${this.state.AsulbName}`,

                                })
                                    .then((response) => {
                                        this.setState({
                                            optOptions: response.data.data.operators
                                        })
                                    })
                            }
                        })
                    }

                }).catch((err) => {
                    swal({
                        icon: "error",
                        title: err
                    })
                })
        }
    }
    static defaultProps = {
        center: {
            lat: 17.123184,
            lng: 79.208824
        },
        zoom: 7,
        maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo"
    };


    handleMapClick(x) {

        this.setState({ latitude: x.lat, longitude: x.lng }, () => {
            this.checkValidity()
        })
    }
    handleMap = (value) => {
        if (document.fullscreenElement) {
            this.setState({ position: 'fixed', top: 0, left: 0 })
            const screenClass = document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenClass.length; index++) {
                const element = screenClass[index];
                element.style["left"] = "709px";
                element.style.top = "285px";
            }
        }
        else {
            this.setState({ position: 'inherit', top: '50%', left: '50%' })
            const screenDeClass = document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenDeClass.length; index++) {
                const elementOff = screenDeClass[index];
                elementOff.style["left"] = "363px";
                elementOff.style.top = "unset";

            }
        }
    }
    AshandleMapClick(x) {
        this.setState({ Aslatitude: x.lat }, () => {
            this.checkValidity()
        })
        this.setState({ Aslongitude: x.lng })
    }
    AshandleMap = (value) => {
        if (document.fullscreenElement) {
            this.setState({ position: 'fixed', top: 0, left: 0 })
            const screenClass = document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenClass.length; index++) {
                const element = screenClass[index];
                element.style["left"] = "709px";
                element.style.top = "285px";
            }
        }
        else {
            this.setState({ position: 'inherit', top: '50%', left: '50%' })
            const screenDeClass = document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenDeClass.length; index++) {
                const elementOff = screenDeClass[index];
                elementOff.style["left"] = "363px";
                elementOff.style.top = "unset";

            }
        }
    }
    handleNewCreationDetail = (flag) => {
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const center = {
                lat: latitude,
                lng: longitude
            }

            this.setState({
                latitude: latitude,
                longitude: longitude,
                center: center,
                zoom: 18
            });
        };

        const error = () => {
            console.log("Unable to retrieve your location");
        };
        navigator.permissions.query({ name: 'geolocation' }).then(permission => {
            if (permission.state === "granted") {
                navigator.geolocation.getCurrentPosition(success, error);

            }
            else if (permission.state === "prompt") {
                const tsCenter = {
                    lat: 17.8302,
                    lng: 79.2778
                }
                this.setState({
                    latitude: 17.8302,
                    longitude: 79.2778,
                    center: tsCenter,
                    zoom: 7
                });
            }
            else if (permission.state === "denied") {
                const tsCenter = {
                    lat: 17.8302,
                    lng: 79.2778
                }
                this.setState({
                    latitude: 17.8302,
                    longitude: 79.2778,
                    center: tsCenter,
                    zoom: 7
                });
            }

        })
        this.setState({
            openNewCreation: flag, 
            openHouseCreation: false, 
            openTaxAssessCreation: false, 
            houseNo: "", 
            assessmentNo: "", 
            assessmentNoFlag: false, 
            houseNoFlag: false,
            ownerName: "",
            locality: "",
            usage: "",
            pincode: "",
            ulbName: "",
            assessNoField: "",
            houseNoField: "",
            ownerName: "",
            buildingName: "",
            propType: "",
            area: "",
            wardNo: "",
            zone: "",
            containmentType: "",
            selectDayMonth: '',
            months: '',
            days: '',
            img: {
                name: "",
            },
            searchByFields: '',
            phoneNumber: '',
            emergency: "",
            pincode: "",
            captcha: "",
            reason: "",
            operatorName: "",
            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            timeRange: "08:00 AM - 10:00 AM",

        })
    }
    handleHouseCreationDetail = (f) => {
        this.setState({
            openHouseCreation: f,
            openTaxAssessCreation: false,
            openNewCreation: false,
            assessmentNo: "",
            assessmentNoFlag: false,
            pincode: "",
            ulbName: "",
            assessNoField: "",
            houseNoField: "",
            buildingName: "",
            propType: "",
            area: "",
            wardNo: "",
            zone: "",
            containmentType: "",
            phoneNumber: "",
            selectDayMonth: '',
            months: '',
            days: '',
            img: {
                name: "",
            },
            searchByFields: '',
            emergency: "",
            captcha: "",
            reason: "",
            operatorName: "",
            optOptions:[],
            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            timeRange: "08:00 AM - 10:00 AM",

        })
    }
    handleTaxAssesCreationDetail = (val) => {
        this.setState({
            openTaxAssessCreation: val,
            openHouseCreation: false,
            openNewCreation: false,
            houseNo: "",
            houseNoFlag: false,
            ownerName: "",
            locality: "",
            usage: "",
            pincode: "",
            ulbName: "",
            assessNoField: "",
            houseNoField: "",
            buildingName: "",
            propType: "",
            area: "",
            wardNo: "",
            zone: "",
            containmentType: "",
            phoneNumber: "",
            selectDayMonth: '',
            months: '',
            days: '',
            img: {
                name: "",
            },
            searchByFields: '',
            emergency: "",
            captcha: "",
            reason: "",
            operatorName: "",
            optOptions:[],
            selectedDate:moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            timeRange: "08:00 AM - 10:00 AM",

        })
    }

    getCurrentLocation = () => {
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const center = {
                lat: latitude,
                lng: longitude
            }

            this.setState({
                Aslatitude: latitude,
                Aslongitude: longitude,
                asCenter: center,
                latitude: latitude,
                longitude: longitude,
                center: center,
                zoom: 18
            });
        };

        const error = () => {
            swal({
                icon: 'warning',
                title: "Browser location is blocked",
                text: "Kindly unlocked the location from setting."
            })
        };
        navigator.permissions.query({ name: 'geolocation' }).then(permission => {
            if (permission.state === "granted") {
                navigator.geolocation.getCurrentPosition(success, error);
            }
            else if (permission.state === "prompt") {
                navigator.geolocation.getCurrentPosition(success, error);
            }
            else if (permission.state === "denied") {
                navigator.geolocation.getCurrentPosition(success, error);
            }

        })
    }
    handleChangeDate = (date) => {
        this.setState({ selectedDate: moment(date).format("YYYY-MM-DD hh:mm:ss") })
    }
    render() {
        const { t, i18n } = this.props
        return (
            <div>
                <div className="dashboard_right_content" style={{ backgroundColor: '#283046', borderRadius: "0px" }}>

                    <div className="create_ulb_content_outer">
                        <div className="create_ulb_content create_ulb_content" >
                            <div className="shadow">
                                <h2 style={{ color: '#283046', fontFamily: "auto" }}>Citizen Request Form</h2>

                                <Grid container spacing={1} style={{ marginTop: '30px' }}>
                                    <Grid item xs={4}>
                                        <div >
                                            <Button onClick={() => this.handleHouseCreationDetail(true)} className='newCreation' style={{ fontFamily: "auto", fontWeight: "bold", width: "100%", color: "gold", backgroundColor: "#283046", }} variant='container'>
                                                {t("SearchbyHouseNo")} </Button>
                                        </div>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <div >
                                            <Button onClick={() => this.handleTaxAssesCreationDetail(true)} className='newCreation' style={{ fontFamily: "auto", fontWeight: "bold", width: "100%", color: "gold", backgroundColor: "#283046", }} variant='container'>
                                                {t("SearchbyTaxAssessmentNo")} </Button>
                                        </div>

                                    </Grid>
                                    <Grid item xs={4}>
                                        <div >
                                            <Button onClick={() => this.handleNewCreationDetail(true)} className='newCreation' style={{ fontFamily: "auto", fontWeight: "bold", width: "100%", color: "gold", backgroundColor: "#283046", }} variant='container'>
                                                {t("CreateNew")}</Button>
                                        </div>

                                    </Grid>
                                    {this.state.openHouseCreation == true ? <>
                                        <Grid item xs={4}>
                                            <hr style={{ border: "1px solid #283046", width: "10%", marginBottom: "15px" }}></hr>

                                        </Grid>
                                        <Grid item xs={4}>  </Grid>
                                        <Grid item xs={4} ></Grid>

                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="" htmlFor="houseNo" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("SearchbyHouseNo")}</label>
                                                <TextField
                                                    // label="House No."
                                                    variant="outlined"
                                                    value={this.state.houseNo}
                                                    onChange={this.handleChange}
                                                    name="houseNo"
                                                    className='searchText'
                                                    placeholder={t('Enterhouseno')}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <>
                                                                <InputAdornment id='searchicon'>
                                                                    <IconButton >
                                                                        <SearchIcon className='searchNo' onClick={() => this.handleSearchHouseNo(this.state.houseNo)} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                                <span id="onhoverfb">{t("msgHover")}</span>
                                                            </>
                                                        )
                                                    }}
                                                />

                                                <div style={{ fontSize: 12, color: "red", fontFamily: "auto", }}>{this.state.houseNoErr}</div>
                                            </FormControl>
                                        </Grid><Grid item xs={6}></Grid>
                                    </> : ""}
                                    {
                                        this.state.openTaxAssessCreation === true ? <>
                                            <Grid item xs={4}>
                                                <hr style={{ border: "1px solid #283046", width: "10%", marginBottom: "15px" }}></hr>

                                            </Grid>
                                            <Grid item xs={4}>  </Grid>
                                            <Grid item xs={4} ></Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="" htmlFor="assessmentNo" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("SearchbyTaxAssessmentNo")}</label>

                                                    <TextField
                                                        variant="outlined"
                                                        value={this.state.assessmentNo}
                                                        onChange={this.handleChange}
                                                        className="type-asses"
                                                        name="assessmentNo"
                                                        type='number'
                                                        placeholder={t('EnterTaxAssessmentNo')}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <>
                                                                    <InputAdornment id='searchicon'>
                                                                        <IconButton >
                                                                            <SearchIcon className='searchNo' onClick={() => this.handleSearchAssessmentNo(this.state.assessmentNo)} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                    <span id="onhoverfb">{t("taxhoverMsg")}</span>
                                                                </>


                                                            )
                                                        }}
                                                    />

                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.assessmentNoErr}</div>
                                                </FormControl>
                                            </Grid><Grid item xs={6}></Grid>
                                        </> : ""
                                    }


                                    {(this.state.houseNo == "" && this.state.assessmentNo == "" && this.state.openNewCreation == true && this.state.houseNoFlag == false && this.state.assessmentNoFlag == false) || (this.state.houseNoFlag == true && this.state.assessmentNoFlag == false && this.state.openNewCreation == false && this.state.houseNo != "") ? <>
                                        <Grid item xs={4}>
                                            <hr style={{ border: "1px solid #283046", width: "10%", marginBottom: "15px" }}></hr>

                                        </Grid>
                                        <Grid item xs={4}>

                                        </Grid>
                                        <Grid item xs={4} ></Grid>
                                        {this.state.houseNoFlag == true ? <Grid item xs={6}>
                                            <FormControl>
                                                <label style={{ fontFamily: "auto", color: "#283046" }} className="" htmlFor="assessNoField" align="left">{t("TaxAssessmentNo")}</label>
                                                <TextField

                                                    variant="outlined"
                                                    value={this.state.assessNoField}
                                                    onChange={this.handleChange}
                                                    name="assessNoField"
                                                    disabled={this.state.houseNo != "" ? true : false}
                                                    placeholder={t('phtaxass')}
                                                />

                                                <div style={{ fontSize: 12, color: "red" }}>{this.state.assessNoFieldErr}</div>
                                            </FormControl>
                                        </Grid> : this.state.openNewCreation == true ? <>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="" style={{ fontFamily: "auto", color: "#283046" }} htmlFor="houseNoField" align="left">{t("HouseNo")}</label>
                                                    <TextField
                                                        variant="outlined"
                                                        value={this.state.houseNoField}
                                                        onChange={this.handleChange}
                                                        name="houseNoField"
                                                        disabled={this.state.houseNo != "" ? true : false}
                                                        placeholder={t("phhouse")}
                                                    />

                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.houseNoFieldErr}</div>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="" style={{ fontFamily: "auto", color: "#283046" }} htmlFor="assessNoField" align="left">{t("TaxAssessmentNo")}</label>
                                                    <TextField

                                                        variant="outlined"
                                                        value={this.state.assessNoField}
                                                        onChange={this.handleChange}
                                                        name="assessNoField"
                                                        disabled={this.state.houseNo != "" ? true : false}
                                                        placeholder={t("phtaxass")}
                                                    />

                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.assessNoFieldErr}</div>
                                                </FormControl>
                                            </Grid>
                                        </> : ""}
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="ownerName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("ownerName")}</label>
                                                <TextField id="ownerName"
                                                    variant="outlined"
                                                    value={this.state.ownerName}
                                                    onChange={this.handleChange}
                                                    name="ownerName"
                                                    disabled={this.state.houseNo != "" ? true : false}
                                                    placeholder={t("phownerName")} />
                                                <div style={{ fontSize: 12, color: "red" }}>{this.state.ownerNameErr}</div>
                                            </FormControl>
                                        </Grid>



                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="" htmlFor="locality" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Locality")}</label>
                                                <TextField id="locality"
                                                    variant="outlined"
                                                    value={this.state.locality}
                                                    onChange={this.handleChange}
                                                    disabled={this.state.houseNo != "" ? true : false}
                                                    name="locality"
                                                    placeholder={("Enter Locality")} />
                                                {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.localityErr}</div> */}
                                            </FormControl>
                                        </Grid>


                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className='' htmlFor="pincode" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Pincode")}</label>
                                                <TextField id="pincode"
                                                    variant="outlined"
                                                    value={this.state.pincode}
                                                    onChange={this.handleChange}
                                                    disabled={this.state.houseNo != "" ? true : false}
                                                    name="pincode"
                                                    placeholder={("Enter Pincode")} />
                                                {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.pincodeErr}</div> */}
                                            </FormControl>

                                        </Grid>
                                        {this.state.usage == "" ? <Grid item xs={6}>

                                            <FormControl>
                                                <label className="" htmlFor="usage" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Usage")}</label>
                                                <Select value={this.state.usage} onChange={this.handleChange} name="usage">
                                                    {!!this.state.usageOptions && this.state.usageOptions.map((option) => (
                                                        <MenuItem value={option.Name}>{option.Name}</MenuItem>
                                                    ))}
                                                </Select>

                                            </FormControl>


                                        </Grid> : <Grid item xs={6}>
                                            <FormControl>
                                                <label className='' htmlFor="usage" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Usage")}</label>
                                                <TextField id="usage"
                                                    variant="outlined"
                                                    value={this.state.usage}
                                                    onChange={this.handleChange}
                                                    disabled={this.state.houseNo != "" ? true : false}
                                                    name="usage"
                                                    placeholder={t("Enter usage")} />
                                                {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.usageErr}</div> */}
                                            </FormControl></Grid>}
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="ulbName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("ulb")}</label>
                                                <Select value={this.state.ulbName} onChange={this.handleChange} name="ulbName">
                                                    {this.state.ulbOptions.map((option) => (
                                                        <MenuItem value={option.Id}>{option.Name}</MenuItem>
                                                    ))}
                                                </Select>

                                                <div style={{ fontSize: 12, color: "red" }}>{this.state.ulbNameErr}</div>
                                            </FormControl>
                                        </Grid>


                                        {this.state.openNewCreation == true ? <Grid item xs={6}></Grid> : ""}

                                    </> : ""}

                                    {
                                        this.state.assessmentNo != "" && this.state.assessmentNoFlag == true && this.state.openNewCreation == false && this.state.houseNoFlag == false ? <>
                                            <Grid item xs={4}>
                                                <hr style={{ border: "1px solid #283046", width: "10%", marginBottom: "15px" }}></hr>

                                            </Grid>
                                            <Grid item xs={4}>

                                            </Grid>
                                            <Grid item xs={4} ></Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="AsownerName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("ownerName")}</label>
                                                    <TextField id="AsownerName"
                                                        variant="outlined"
                                                        value={this.state.AsownerName}
                                                        onChange={this.handleChange}
                                                        name="AsownerName"
                                                        disabled={this.state.AsownerName != "" ? true : false}
                                                        placeholder={t("phownerName")} />
                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.AsownerNameErr}</div>
                                                </FormControl>
                                            </Grid>


                                            {this.state.assessmentNoFlag == true ? <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="" htmlFor="houseNoField" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("HouseNo")}</label>
                                                    <TextField

                                                        variant="outlined"
                                                        value={this.state.houseNoField}
                                                        onChange={this.handleChange}
                                                        name="houseNoField"
                                                        disabled={this.state.houseNoField != "" ? true : false}
                                                        placeholder={t("Enterhouseno")}
                                                    />
                                                </FormControl>
                                            </Grid> : ""}
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="" htmlFor="Aslocality" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Locality")}</label>
                                                    <TextField id="Aslocality"
                                                        variant="outlined"
                                                        value={this.state.Aslocality}
                                                        onChange={this.handleChange}
                                                        disabled={this.state.Aslocality != "" ? true : false}
                                                        name="Aslocality"
                                                        placeholder={t("EnterLocality")} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className='' htmlFor="Aspincode" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Pincode")}</label>
                                                    <TextField id="Aspincode"
                                                        variant="outlined"
                                                        value={this.state.Aspincode}
                                                        onChange={this.handleChange}
                                                        disabled={this.state.Aspincode != "" ? true : false}
                                                        name="Aspincode"
                                                        placeholder={t("placeholderPincode")} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className='' htmlFor="Asusage" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Usage")}</label>
                                                    <TextField id="Asusage"
                                                        variant="outlined"
                                                        value={this.state.Asusage}
                                                        onChange={this.handleChange}
                                                        disabled={this.state.Asusage != "" ? true : false}
                                                        name="Asusage"
                                                        placeholder={t("Enterusage")} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="AsulbName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("ulb")}</label>
                                                    <Select value={this.state.AsulbName} onChange={this.handleChange} name="AsulbName">
                                                        {this.state.ulbOptions.map((option) => (
                                                            <MenuItem value={option.Id}>{option.Name}</MenuItem>
                                                        ))}
                                                    </Select>

                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.AsulbNameErr}</div>
                                                </FormControl>
                                            </Grid>
                                        </> : ""
                                    }
                                    <Grid item xs={4}>
                                        <hr style={{ border: "1px solid #283046", width: "10%", marginBottom: "15px" }}></hr>

                                    </Grid>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={4} ></Grid>

                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label className="required" htmlFor="containmentType" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("containmentType")}</label>
                                            <Select value={this.state.containmentType} onChange={this.handleChange} name="containmentType">
                                                {this.state.containmentOptions.map((option) => (
                                                    <MenuItem value={option.Id}>{option.Name}</MenuItem>
                                                ))}
                                            </Select>
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.containmentTypeErr}</div>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label className="required" htmlFor="propType" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("propType")}</label>
                                            <Select value={this.state.propType} onChange={this.handleChange} name="propType" placeholder="Select Property Type">
                                                {this.state.propertyOptions.map((option) => (
                                                    <MenuItem value={option.Id}>{option.Name}</MenuItem>
                                                ))}
                                            </Select>
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.propTypeErr}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label className="required" htmlFor="phoneNumber" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("phoneNumber")}</label>
                                            <TextField id="phoneNumber"
                                                variant="outlined"
                                                type='number'
                                                value={this.state.phoneNumber}
                                                onChange={this.handleChange}
                                                name="phoneNumber"
                                                placeholder={t("phPhoneNumber")} />
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.phoneNumberErr}</div>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label className="" htmlFor="buildingName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("propAddress")}</label>
                                            <TextField id="buildingName"
                                                variant="outlined"
                                                value={this.state.buildingName}
                                                onChange={this.handleChange}
                                                name="buildingName"
                                                placeholder={t("phpropAddress")} />
                                            {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.buildingNameErr}</div> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label htmlFor="zone" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("zoneName")} </label>
                                            <TextField id="zone"
                                                variant="outlined"
                                                value={this.state.zone}
                                                onChange={this.handleChange}
                                                name="zone"
                                                disabled={this.state.houseNo != "" || this.state.assessmentNo != "" ? true : false}
                                                placeholder={t("phZone")} />
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.zoneErr}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label htmlFor="wardNo" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("wardNo")}</label>
                                            <TextField id="wardNo"
                                                variant="outlined"
                                                value={this.state.wardNo}
                                                onChange={this.handleChange}
                                                name="wardNo"
                                                disabled={this.state.houseNo != "" || this.state.assessmentNo != "" ? true : false}
                                                placeholder={t("phWard")} />
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.wardNoErr}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label htmlFor="emergency" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("emergency")} </label>
                                            <Select value={this.state.emergency} onChange={this.handleChange} name="emergency">
                                                <MenuItem value={'Yes'}>{"Yes"}</MenuItem>
                                                <MenuItem value={'No'}>{"No"}</MenuItem>
                                            </Select>
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.emergencyErr}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label className="required" htmlFor="operatorName" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("operatorName")} </label>
                                            <Select value={this.state.operatorName} onChange={this.handleChange} name="operatorName">
                                                {this.state.optOptions && this.state.optOptions.map((item) => {
                                                    return <MenuItem value={item.id}>{item.name}</MenuItem>

                                                })}
                                            </Select>
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.optOptions.length == 0 ? "Please select the ulb " : this.state.opertorErr}</div>
                                        </FormControl>
                                    </Grid>
                                    {
                                        this.state.operatorName != "" ? <>
                                            <Grid item xs={6}>
                                                <label className="" htmlFor="" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{("Date to Visit")} </label>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>

                                                    <DatePicker
                                                        variant="inline"
                                                        value={this.state.selectedDate}
                                                        onChange={this.handleChangeDate}
                                                        disablePast
                                                        format='dd MMM YYY'
                                                        autoOk
                                                        style={{ width: '100%', borderBottom: 'none' }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 'small', padding: '4px', marginTop: '2px', color: '#283046', border: '1px solid #283046',
                                                                borderRadius: '4px', fontFamily: 'auto'
                                                            }, disableUnderline: true
                                                        }} />

                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl >
                                                    <label htmlFor="timeRange" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("Time Range")} </label>
                                                    <Select value={this.state.timeRange} onChange={this.handleChange} name="timeRange">
                                                        <MenuItem value={`08:00 AM - 10:00 AM`}>{`08:00 AM - 10:00 AM`}</MenuItem>
                                                        <MenuItem value={`10:00 AM - 12:00 PM`}>{`10:00 AM - 12:00 PM`}</MenuItem>
                                                        <MenuItem value={`12:00 PM - 02:00 PM`}>{`12:00 PM - 02:00 PM`}</MenuItem>
                                                        <MenuItem value={`02:00 PM - 04:00 PM`}>{`02:00 PM - 04:00 PM`}</MenuItem>
                                                        <MenuItem value={`04:00 PM - 06:00 PM`}>{`04:00 PM - 06:00 PM`}</MenuItem>
                                                        <MenuItem value={`06:00 PM - 08:00 PM`}>{`06:00 PM - 08:00 PM`}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                             </>
                                            : ""
                                    }
                                    <Grid item xs={6}>
                                        <FormControl variant="outlined" size="small" >
                                            <label style={{ fontFamily: "auto", color: "#283046" }}>{t("uploadPhoto")}</label>      <span style={{ display: 'flex' }}>
                                                <ImageUploader style={{ align: 'left' }} withIcon={false}
                                                    singleImage={true}
                                                    fileContainerStyle={{ color: '#283046' }}
                                                    buttonText='Upload'
                                                    buttonStyles={{ backgroundColor: 'white', color: 'gold', fontSize: '12px', borderRadius: '5px', align: 'left', height: '35px', width: '100%', padding: '0px', marginTop: '1px', marginBottom: '0%', height: "45px" }}
                                                    withLabel={false}
                                                    value={this.state.img}
                                                    onChange={this.handleImage}
                                                    imgExtension={['.jpg', '.png', '.jpeg']}
                                                    fileSizeError="Can not upload the photo!"
                                                    fileTypeError=" is not supported file extension"
                                                    maxFileSize={5242880}

                                                    buttonClassName="imgButtonEnable"
                                                />
                                                {this.state.isLogo &&
                                                    <CancelIcon style={{ fontSize: 'large', color: '#f51c00' }} onClick={this.handleRemove} />
                                                }
                                            </span>
                                            {this.state.imgErr ?
                                                <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "5%", lineHeight: '11px' }}>{this.state.imgErr}</div>
                                                :
                                                <div>{"Upload Photo"}</div>
                                            }

                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label style={{ fontFamily: "auto", color: "#283046" }} htmlFor="selectDayMonth" align="left">{t("lastEmptied")} </label>
                                            <Select value={this.state.selectDayMonth} onChange={this.handleChange} name="selectDayMonth">
                                                <MenuItem value={'M'}>{'Months'}</MenuItem>
                                                <MenuItem value={'D'}>{"Days"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {this.state.selectDayMonth == 'M' ?
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label style={{ fontFamily: "auto", color: "#283046" }} className="required" htmlFor="months" align="left">{t("months")}</label>
                                                    <TextField id="months"
                                                        variant="outlined"
                                                        value={this.state.months}
                                                        onChange={this.handleChange}
                                                        name="months"
                                                        placeholder={t("phMonths")} />
                                                </FormControl>
                                            </Grid>
                                            : this.state.selectDayMonth == 'D' ? <Grid item xs={6}>
                                                <FormControl>
                                                    <label style={{ fontFamily: "auto", color: "#283046" }} className="required" htmlFor="days" align="left">{("Days")}</label>
                                                    <TextField id="days"
                                                        variant="outlined"
                                                        value={this.state.days}
                                                        onChange={this.handleChange}
                                                        name="days"
                                                        placeholder={t("phDays")} />
                                                </FormControl>
                                            </Grid> : ''}
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <label htmlFor="reason" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("comment")}</label>
                                            <TextField id="reason"
                                                variant="outlined"
                                                value={this.state.reason}
                                                onChange={this.handleChange}
                                                name="reason"
                                                placeholder={t("phComment")} />
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.reasonErr}</div>
                                        </FormControl>
                                    </Grid>
                                    {this.state.selectDayMonth != "" ?
                                        "" : <Grid item xs={6}></Grid>
                                    }
                                    {(this.state.houseNo == "" && this.state.assessmentNo == "" && this.state.openNewCreation == true && this.state.houseNoFlag == false && this.state.assessmentNoFlag == false) || (this.state.houseNoFlag == true && this.state.assessmentNoFlag == false
                                        && this.state.openNewCreation == false && this.state.houseNo != "") ? <>
                                        <Grid item xs={12}>
                                            <div style={{ height: '30vh', width: '100%', paddingBottom: '15px', position: this.state.position, top: this.state.top, left: this.state.left }}>
                                                <GoogleMapReact
                                                    yesIWantToUseGoogleMapApiInternals
                                                    bootstrapURLKeys={{ key: this.state.maps_key }}
                                                    center={this.state.center}
                                                    zoom={this.state.zoom}
                                                    onClick={this.handleMapClick}
                                                    onChange={this.handleMap}
                                                    showsUserLocation={true}
                                                    showsMyLocationButton={true}
                                                >
                                                    <Marker
                                                        lat={this.state.latitude}
                                                        lng={this.state.longitude}
                                                        name="My Marker"
                                                        color="blue" />
                                                    <div className='current-loct'>
                                                        <MyLocationRoundedIcon className='myloct' onClick={() => this.getCurrentLocation()} />
                                                    </div>
                                                </GoogleMapReact>
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="latitude" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("latitude")}</label>
                                                <OutlinedInput id="latitude"
                                                    variant="outlined"
                                                    disabled
                                                    value={evaluateLocation(this.state.latitude)}
                                                    onChange={this.handleChange}
                                                    name="latitude"
                                                    placeholder={t("EnterLatitude")}
                                                    endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                <div style={{ fontSize: 12, color: "red", }}>{this.state.latitudeErr}</div>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="longitude" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{t("longitude")}</label>
                                                <OutlinedInput id="longitude"
                                                    variant="outlined"
                                                    disabled
                                                    value={evaluateLocation(this.state.longitude)}
                                                    onChange={this.handleChange}
                                                    name="longitude"
                                                    placeholder={t("EnterLongitude")}
                                                    endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                <div style={{ fontSize: 12, color: "red" }}>{this.state.longitudeErr}</div>
                                            </FormControl>

                                        </Grid>
                                    </> : ""}
                                    {this.state.assessmentNo != "" && this.state.assessmentNoFlag == true && this.state.openNewCreation == false && this.state.houseNoFlag == false ? <>
                                            <Grid item xs={12}>
                                                <div style={{ height: '30vh', width: '100%', paddingBottom: '15px', position: this.state.position, top: this.state.top, left: this.state.left }}>
                                                    <GoogleMapReact
                                                        bootstrapURLKeys={{ key: this.state.maps_key }}
                                                        center={this.state.asCenter}
                                                        zoom={this.state.zoom}
                                                        onClick={this.AshandleMapClick}
                                                        onChange={this.AshandleMap}>
                                                        <Marker
                                                            lat={this.state.Aslatitude}
                                                            lng={this.state.Aslongitude}
                                                            name="My Marker"
                                                            color="blue" />

                                                        <div className='current-loct'>
                                                            <MyLocationRoundedIcon className='myloct' onClick={() => this.getCurrentLocation()} />
                                                        </div>
                                                    </GoogleMapReact>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="latitude" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{("Latitude")}</label>
                                                    <OutlinedInput id="latitude"
                                                        variant="outlined"
                                                        disabled
                                                        value={evaluateLocation(this.state.Aslatitude)}
                                                        onChange={this.AshandleChange}
                                                        name="Aslatitude"
                                                        placeholder={("Enter Latitude")}
                                                        endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                    <div style={{ fontSize: 12, color: "red", }}>{this.state.AslatitudeErr}</div>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="longitude" align="left" style={{ fontFamily: "auto", color: "#283046" }}>{("Longitude")}</label>
                                                    <OutlinedInput id="longitude"
                                                        variant="outlined"
                                                        disabled
                                                        value={evaluateLocation(this.state.Aslongitude)}
                                                        onChange={this.handleChange}
                                                        name="Aslongitude"
                                                        placeholder={("Enter Longitude")}
                                                        endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                    <div style={{ fontSize: 12, color: "red" }}>{this.state.AslongitudeErr}</div>
                                                </FormControl>

                                            </Grid>
                                        </> : ""}
                                    <Grid item xs={6}>
                                        <div>
                                            <img src="images/bg6.png" alt="background" height="50" width="100%" style={{ marginTop: "20px" }} />
                                            <h3 id="captcha" style={{ textAlign: 'center', marginTop: '-35px', }}>{this.state.randomCaptcha}</h3>
                                        </div>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <FormControl>
                                            <label className="required" htmlFor="Captcha" align="left" style={{ fontFamily: "auto", color: "#283046" }}>Captcha</label>
                                            <TextField id="inputType"
                                                type='text'
                                                variant="outlined"
                                                value={this.state.captcha}
                                                onChange={this.handleChange}
                                                name="captcha"
                                                placeholder="Enter Captcha" />
                                            <div style={{ fontSize: 12, color: "red" }}>{this.state.captchaErr}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <div className="create_ulb_buttons">
                                                <Button className="login_submit" variant="outlined" color="primary" style={{ borderColor: "#283046", color: "#283046", fontWeight: "bold", fontFamily: "auto", fontSize: "20px" }} onClick={this.handleCancle}>Cancel</Button>
                                                <Button id="succesBTN" className="login_submit" style={{ backgroundColor: "#283046", color: "gold", fontWeight: "bold", fontFamily: "auto", fontSize: "20px" }} variant="contained" color="primary" onClick={this.handleSubmit}>Submit</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

/**
 * Evaluates lat long for 4 digit precision
 * @param {*} loc - Lat Long for evaluation
 */
function evaluateLocation(loc) {
    return loc.toString().length > 0 ? parseFloat(loc).toFixed(4) : "";
}
const mapStateToProps = state => {
    return {
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCitizenPropertyAdd: (payload, props) => dispatch(actionsCreators.citizenPropertyAdd(payload, props))

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Citizen));
